import "./SiteUsersList.html";
import "./SiteUsersList.scss";

import "./AddUserToSite/AddUserToSiteComponent";
import "./EditUserOnSite/EditUserOnSiteComponent";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import SiteUsersListComponentController from "./SiteUsersListComponentController";

export class SiteUsersListComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            siteId: "<",
        };
        this.controller = SiteUsersListComponentController;
        this.templateUrl = "/App/Components/Site/UsersList/SiteUsersList.html";
    }
}

module("mmManagePortal").component("mmSiteUsersList", new SiteUsersListComponent());
